module.exports = __webpack_public_path__ + "img/PFSCHelp1.1f6339f6.png";